import { render } from "./ImportWorkstationModal.vue?vue&type=template&id=084c8715&scoped=true&ts=true"
import script from "./ImportWorkstationModal.vue?vue&type=script&lang=ts"
export * from "./ImportWorkstationModal.vue?vue&type=script&lang=ts"

import "./ImportWorkstationModal.vue?vue&type=style&index=0&id=084c8715&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084c8715"]])

export default __exports__